export default "__VITE_ASSET__a676d842__"